import _ from 'lodash';
import dayjs from 'dayjs';

const getDetailedTourData = (tourItinerary, currencySign) => {
  const { tour, selectedSlot } = tourItinerary || {};

  let data = 'Tour details:\n';
  data += `Tour: ${tour?.name}\n`;
  data += `Tour ID: ${tourItinerary?.productId}\n`;
  data += `Type: ${tour?.productType || 'N/A'}\n`;
  data += `Where: ${tourItinerary?.destination || 'N/A'}\n`;
  data += `Duration: ${tour?.durationText || 'N/A'}\n`;
  data += `Operated by: ${tour?.supplierName || 'N/A'}\n`;
  if (tour?.rating) {
    data += `Rating: ${tour.rating}\n`;
  }
  _.each(tour?.activities, (activity) => {
    data += `- ${activity}\n`;
  });

  if (selectedSlot) {
    data += '\nSelected departure:\n';
    data += `Date: ${dayjs(selectedSlot.date).format('MMM D, YYYY')}\n`;
    if (selectedSlot.time) {
      data += `Time: ${selectedSlot.time}\n`;
    }
    if (selectedSlot.slotDescription) {
      data += `Option: ${selectedSlot.slotDescription}\n`;
    }
    _.each(_.keys(selectedSlot.rateQuantities), (rate) => {
      data += `- ${rate}: ${selectedSlot.rateQuantities[rate]}\n`;
    });
    if (selectedSlot.guests) {
      data += `Travellers: ${selectedSlot.guests}\n`;
    }
    data += `Price: ${currencySign}${selectedSlot.price}\n`;
  }

  if (tourItinerary?.cancellationPolicy) {
    data += `\nCancellation policy: ${tourItinerary.cancellationPolicy}\n`;
  }
  if (tour?.meetingNotes) {
    data += `Meeting point: ${tour.meetingNotes}\n`;
  }

  return data;
};

export default getDetailedTourData;
